<div class="container-box p-3 overflow-auto">
  <app-loading-section *ngIf="isLoading && !amenitiesArray.length"></app-loading-section>
  <div class="d-grid gap-2" style="grid-template-columns: repeat(2, 1fr)">
    <ng-container *ngFor="let item of amenitiesArray.controls" [formGroup]="item">
      <mat-checkbox formControlName="enabled" (change)="onToggleItem(item, $event.checked)">{{
        item.get('name').value | titleCase
      }}</mat-checkbox>
    </ng-container>
  </div>
</div>
